// extracted by mini-css-extract-plugin
module.exports = {"container":"Home__container___h1Tk-","main":"Home__main___SCUBv contentCell__contentCell___KzZ1t"};